<template>
  <div class="orderContainer" v-sound>
    <h2 class="orderTitle">注文一覧</h2>
    <hr class="titleLine" />

    <div class="orderList">
      <table class="orderTable">
        <thead>
          <tr> 
            <th>商品名</th>
            <th>数量</th>
            <th>注文卓</th>
            <th>提供状況</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orderitems" :key="order.id">
            <td><p v-html="order.menuitems.label"></p></td>
            <td>{{ order.quantity }}</td>
            <td>{{ getDiningTablesLabel(order.orders.dining_table_id) }}</td>
            <td>
              <input 
                type="checkbox" 
                :checked="order.status === 1" 
                @change="updateOrderStatus(order)" 
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="footerContainer">
      <div class="buttonContainer">
        <button class="backButton" @click="this.$router.push('/checkout-list');">会計確認画面</button>
        <button class="backButton" @click="this.$router.push('/admin');">管理ページTOP</button>
      </div>
      <div class="popupContainer" :class="{ 'is-hidden': checkoutSessions.length === 0 }">
        <p class="popupMessage">{{ checkoutSessions[0]?.diningTables?.label }}お会計です。対応お願いします。</p>
        <button class="popupButton" @click="updateCheckoutFlag">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const POLLING_INTERVAL_ORDER_ITEMS = 15000; // 注文リストのポーリング間隔 (例: 30秒)
const POLLING_INTERVAL_TABLE_SESSIONS = 15000; // テーブルセッションのポーリング間隔 (例: 15秒)

export default {
  data() {
    return {
      orderitems: [],
      diningtables: [],
      activeSessions: [],
      checkoutSessions: [],
      diningTableID: localStorage.getItem('diningTableID'),
    };
  },
  created() {
    this.axios({
      method: 'GET',
      url: '/v1/connection/test',
    })
      .then((response) => {
        console.log(response.data.status);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
    this.getOrderItems();
    this.getDiningTables();
  },
  computed: {
    ...mapState(['user', 'cart', 'helper']),
  },
  mounted() {
    // ポーリング開始
    this.orderPollingId = setInterval(this.getOrderItems, POLLING_INTERVAL_ORDER_ITEMS);
    this.sessionPollingId = setInterval(this.getTableSessions, POLLING_INTERVAL_TABLE_SESSIONS);
    //checkoutSessionsが増えたら音を鳴らす
    this.$watch('checkoutSessions', (newSessions, oldSessions) => {
      if (newSessions.length > oldSessions.length) {
        this.checkoutReceivedSound(); // 新しいお会計が追加されたら音を鳴らす
      }
    });
    this.$watch('orderitems', (newItems, oldItems) => {
      if (newItems.length > oldItems.length) {
        this.orderReceivedSound(); // 新しい注文卓が追加されたら音を鳴らす
      }
    });
    //orderitems.menuitems.flag==2　が新たに追加されたら音を鳴らす
    this.$watch('orderitems', (newItems, oldItems) => {
      const newCalledItems = newItems.filter((item) => item.menuitems.flag === 2);
      const oldCalledItems = oldItems.filter((item) => item.menuitems.flag === 2);
      if (newCalledItems.length > oldCalledItems.length) {
        this.staffCalledSound(); // 新しい「呼び出し」注文が追加されたら音を鳴らす
      }
    });
  },
  beforeUnmount() { // Vue 3 では unmounted
    // ポーリング停止
    clearInterval(this.orderPollingId);
    clearInterval(this.sessionPollingId);
  },
  methods: {
    async getOrderItems() {
      await this.getTableSessions();
      this.axios({
        method: 'GET',
        url: '/v1/orderitem/get/list',
        params: {
          order: 's.created_at',
          orderBy: 'desc',
          user_id: this.user.id,
          includeSession: this.activeSessions.map((session) => session.id),
        },
      })
        .then((response) => {
          this.orderitems = response.data.list.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    updateOrderStatus(order) {
      const newStatus = order.status === 1 ? 0 : 1;

      this.axios({
        method: 'POST',
        url: '/v1/orderitem/update',
        data: {
          id: order.id,
          status: newStatus,
          user_id: this.user.id,
        },
      })
        .then(() => {
          order.status = newStatus;
          console.log(`Order ID: ${order.id} status updated to ${newStatus}`);
        })
        .catch((error) => {
          console.error('Failed to update order status:', error.response ? error.response.data : error);
          alert('ステータスの更新に失敗しました。');
        });
    },
    getTableSessions() {
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'GET',
          url: '/v1/tablesession/get/list',
          params: {
            user_id: this.user.id,
          },
        })
          .then((response) => {
            const res = response.data;
            const allSessions = res.list.data;
            // status が 0 (注文中の卓)のものを抽出
            this.activeSessions = allSessions.filter((session) => session.status === 0);
            // status が1 かつconfilrm_flagが0 会計待ちかつ確認ボタンが押されていないものを抽出
            this.checkoutSessions = allSessions.filter((session) => session.status === 1 && session.confirm_flag === 0);
            resolve(); // 非同期処理が成功したらresolveを呼び出す
          })
          .catch((error) => {
            if (error.response) console.log(error.response);
            else console.log(error);
            reject(error); // 非同期処理が失敗したらrejectを呼び出す
          });
      });
    },
    updateCheckoutFlag() {
      // tablesession の status をアップデート
      if (this.checkoutSessions.length > 0) {
        const sessionId = this.checkoutSessions[0].id; // 更新対象のテーブルセッションIDを取得
        this.axios({
          method: 'POST',
          url: '/v1/tablesession/update',
          data: {
            id: sessionId,
            confirm_flag: 1,
            user_id: this.user.id,
          },
        })
          .then((response) => {
            console.log(response.data);
            //checkoutSessionsからupdateしたセッションを削除
            this.checkoutSessions = this.checkoutSessions.filter((session) => session.id !== sessionId);
          })
          .catch((error) => {
            if (error.response) console.log(error.response.data);
            else console.log(error);
          });
      }
    },
    getDiningTables() {
      this.axios({
        method: 'GET',
        url: '/v1/diningtable/get/list',
        params: {
          user_id: this.user.id,
        },
      })
        .then((response) => {
          this.diningtables = response.data.list.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    getDiningTablesLabel(diningTableID) {
      const diningTable = this.diningtables.find((table) => table.id === diningTableID);
      return diningTable ? diningTable.label : '不明な卓';
    },
    orderReceivedSound() {
      const audio = new Audio('/sound/order_received.mp3'); // 音声ファイルのパスを指定
      audio.play();
    },
    checkoutReceivedSound() {
      const audio = new Audio('/sound/checkout_received.mp3'); // 音声ファイルのパスを指定
      audio.play();
    },
    staffCalledSound() {
      const audio = new Audio('/sound/staff_called.mp3'); // 音声ファイルのパスを指定
      audio.play();
    },
  },
};
</script>

<style scoped>
.orderContainer {
  width: 100vw;
  height: 100dvh; 
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 40px 20px;
  position: relative;
}

.orderTitle {
  font-family: 'HGS明朝B', serif;
  font-size: 50px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

.titleLine {
  width: 90%;
  border: 1px solid #333;
  margin-bottom: 20px;
}

.orderList {
  width: 90%;
  height: 60vh;
  overflow-y: auto;
  border: 2px solid #333;
}

.orderTable {
  width: 100%;
  border-collapse: collapse;
  font-family: '游明朝', serif;
  font-size: 26px;
  color: #333;
  background-color: transparent;
}

.orderTable th {
  font-size: 28px;
  font-weight: bold;
  background-color: transparent;
  padding: 10px;
  border: 1px solid #333;
  text-align: center;
  position: sticky;
  top: 0;
  background-image: url('/img/menu/paperboard-texture.jpg');
}

.orderTable td {
  font-size: 24px;
  font-weight: normal;
  padding: 10px;
  border: 1px solid #333;
  text-align: center;
  height: 50px;
  white-space: pre-wrap;
}

.orderTable th:nth-child(1),
.orderTable td:nth-child(1) {
  width: 40%;
}

.orderTable th:nth-child(2),
.orderTable td:nth-child(2) {
  width: 20%;
}

.orderTable th:nth-child(3),
.orderTable td:nth-child(3) {
  width: 20%;
}

.orderTable th:nth-child(4),
.orderTable td:nth-child(4) { 
  width: 20%;
}

.orderTable input[type="checkbox"] {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.footerContainer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2vw;
  padding: 1vh;
  margin-bottom: 3vh;
}

/* 横並びにする */
.buttonContainer {
  display: flex;
  flex-direction: row;
  gap: 2vw;
  align-items: center;
}

/* popup は右側に小さく配置 */
.popupContainer {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 左寄せにする */
  gap: 1.2vw;
  background-color: #FFFFFF;
  border: 2px solid #333;
  border-radius: 12px;
  padding: 1.2vw 1.6vw;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s;
}

.is-hidden {
  visibility: hidden;
}

/* OKボタンをポップアップ内の左に目立つように調整 */
.popupContainer .popupButton {
  margin: 0;
  padding: 8px 18px;
  min-width: 56px;
  height: auto;
  font-size: 1.2vw;
  border-radius: 8px;
}

/* メッセージは折り返し可能にして右側に表示 */
.popupContainer .popupMessage {
  margin: 0;
  padding-left: 0.6vw;
  white-space: normal;
}

.popupButton {
  background-color: #953127;
  color: #FFFFFF;
  font-family: 'HGS明朝B', serif;
  font-size: 1.5vw;
  padding: 8px 15px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  white-space: nowrap;
}

.popupButton:hover {
  background-color: #B03A2E;
}

.buttonContainer {
  display: flex;
  flex-direction: row;
  gap: 2vw;
  align-items: center;
}

/* 余白調整（必要なら） */
.popupContainer {
  margin-left: 1vw;
}

.backButton {
  background-color: transparent;
  color: #333;
  font-family: '游明朝', serif;
  font-size: 1.5vw;
  padding: 10px 30px;
  border: 2px solid #333;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  white-space: nowrap;
}

</style>
